var _path;
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
class IconImageLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
      name: "IconImage",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef
    }), _path || (_path = /*#__PURE__*/React.createElement("path", {
      d: "M1920 113v1694.118H0V113h1920Zm-112.941 112.941H112.94V1694.29h1694.12V225.941ZM935.944 1058.77c182.851-258.409 332.498-286.87 426.691-264.847 160.716 37.384 272.076 242.26 330.805 608.98l10.504 65.392H207.924l20.104-71.718c85.384-306.07 172.913-457.072 283.37-489.712 102.55-30.156 185.336 43.82 258.86 109.1 43.596 38.514 90.806 81.092 122.542 78.834 15.925-1.807 32.188-20.556 43.144-36.029Zm401.167-154.842c-83.012-19.313-196.066 60.762-308.895 220.01-35.237 49.807-76.348 77.816-122.315 83.124-76.226 9.024-138.182-42.827-198.812-96.266l-3.868-3.413c-2.578-2.276-5.154-4.552-7.73-6.824-54.211-48.113-110.682-97.017-152.018-85.384-34.447 10.165-102.325 69.12-185.788 340.179h1212.762c-50.485-265.186-134.4-428.386-233.336-451.426ZM677.647 338.882c124.574 0 225.882 101.309 225.882 225.883 0 124.574-101.308 225.882-225.882 225.882S451.765 689.34 451.765 564.765s101.308-225.883 225.882-225.883Zm0 112.942c-62.343 0-112.941 50.71-112.941 112.94 0 62.231 50.598 112.942 112.941 112.942 62.344 0 112.941-50.71 112.941-112.941 0-62.23-50.597-112.941-112.94-112.941Z",
      fillRule: "evenodd"
    })));
  }
}
IconImageLine.glyphName = 'image';
IconImageLine.variant = 'Line';
IconImageLine.displayName = 'IconImageLine';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconImageLine.propTypes = {
  ...SVGIcon.propTypes
};
IconImageLine.allowedProps = [...SVGIcon.allowedProps];
export default IconImageLine;
export { IconImageLine };